/** Keep a bounded, identity-scoped set of workspace snapshots for return visits. */
const snapshots = new Map<string, unknown>()
const LIMIT = 8

export function rememberWorkspace(key: string, state: unknown) {
  snapshots.delete(key)
  snapshots.set(key, state)
  const oldest = snapshots.keys().next().value
  if (snapshots.size > LIMIT && oldest !== undefined) snapshots.delete(oldest)
}

export function recalledWorkspace(key: string): unknown {
  return snapshots.get(key)
}

export function clearWorkspaceStates() {
  snapshots.clear()
}
